// NPM Imports
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import Modal from "react-responsive-modal";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, withRouter } from "react-router-dom";
// import profilepic from "../../../assets/rep_dp.png";
import { Loader, Toastr, Input } from "@revvsales/components";

// Components Imports
import AddGridColumn from "../../AddGridColumn";
import PricebookWizard from "../PricebookWizard";
import AgGridWrapper from "../../AgGridWrapper";
import AgGridVisibilityCtrl from "../../AgGridVisibilityCtrl";
import { PricelistBar } from "../../ControlBar";
import { Conditional } from "../../../commonComponents";

import { DatePickerEditor } from "../../cell-editors";
import { CheckBoxEditor } from "../../AgGridCellEditor";
import {
  CheckBoxRenderer,
  MultiSelectRenderer,
} from "../../AgGridCellRenderer";
import TogglePBStatusPopup from "./TogglePBStatusPopup";

// commonService
import { fetchAppConfig } from "../../../actions/CommonActions/commonService";
import { getViewConfig } from "../../../actions/PricebooksActions/pricebooksService";
import { signOutUser } from "../../../actions/AuthActions/authActions";
// Actions Imports
import PricebooksActions from "../../../actions/PricebooksActions";
import { GlobalUtils } from "../../../utils";

// Internal Imports
import { COMMON, GRID, PERMISSIONS, LOADING_MSG } from "../../../constants";

// Destructuring
const {
  addColumn,
  getInitData,
  nukeGridData,
  updateFormRowData,
  updatePricebookData,
  updatePricebookInfo,
} = PricebooksActions;
const { CURRENCY_SYMBOL } = COMMON;
const { GRID_PAGE_TYPE } = GRID;
const { handleApiErrMsg, saveGridState, checkUserPermission } = GlobalUtils;

// Declarations
let gridApi = null;
const gridState = `${GRID_PAGE_TYPE.PRICELIST}GridState`;

class PricebookGrid extends Component {
  static rowData = null;

  state = {
    showLoader: false,
    showPricebookWizard: false,
    addGridColumnPopUp: false,
    manageColumnPopUp: false,
    togglePBActiveStatusPopup: false,
    filteredText: "",
    frameworkComponents: {
      CheckBoxEditor,
      CheckBoxRenderer,
      DatePickerEditor,
      MultiSelectRenderer,
    },
  };

  componentDidMount() {
    this._toggleLoader(true);
    getViewConfig(
      this.props.pricelistId,
      CURRENCY_SYMBOL[this.props.selectedPricelist.currency],
    )
      .then(res => {
        console.debug("res", res);
        this._onInit(res);
      })
      .catch(err => {
        fetchAppConfig()
          .then(response => {
            console.debug("configSuccess response", response);
            getViewConfig(
              this.props.pricelistId,
              CURRENCY_SYMBOL[this.props.selectedPricelist.currency],
            )
              .then(res => {
                this._onInit(res);
              })
              .catch(error => {
                signOutUser();
                console.debug("configSuccess response", error);
              });
          })
          .catch(error => {
            signOutUser();
            console.debug("configFails", error);
          });
        console.debug("res", err);
      });
  }

  componentWillUnmount() {
    this.props.nukeGridData();
  }

  // Callback on ag-grid ready state
  _onGridReady = api => {
    gridApi = api;
    GlobalUtils.saveGridAPi(api);
    // To Store & Retrive the user grid state
    // if (readDataFromLocalStorage(gridState)) {
    //   restoreGridState(gridState);
    // } else {
    //   saveGridState(gridState);
    // }
    // Resize columns after it's completly loaded
    api.api.sizeColumnsToFit();
  };

  // Callback when a grid dispay change is detected
  _saveGridState = () => {
    saveGridState(gridState);
  };

  // Callback when a cell change is detected
  _onCellValueChanged = params => {
    const { name } = params.colDef;
    const { field } = params.colDef;
    if (name === "effective_date" || name === "expiry_date") {
      params.data[field] = params.newValue.format();
    }
    this.props.updatePricebookData(params.data, true);
  };

  // Set Right Click options
  _getContextMenuItems = params => {
    const contextMenuItems = [
      "autoSizeAll",
      {
        name: "Reset Columns",
        action: () => gridApi.api.sizeColumnsToFit(),
      },
      "copy",
      "export",
    ];

    // edit pricebook row if user has update permission
    if (checkUserPermission(PERMISSIONS.PRODUCTS.UPDATE_PRODUCTS)) {
      contextMenuItems.unshift({
        name: "Edit Row",
        action: () => {
          PricebookGrid.rowData = params.node.data;
          this._togglePopUp("showPricebookWizard", true);
        },
      });
    }
    return contextMenuItems;
  };

  _togglePopUp = (type, flag) => {
    this.setState({ [type]: flag });
    if (!flag) {
      PricebookGrid.rowData = null;
    }
  };

  _addColumn = payload => {
    this.props.addColumn(payload, this.props.pricelistId).then(() => {
      Toastr.showToastr({
        type: "success",
        message: "Column added successful!",
        timeout: 2000,
      });
      this._togglePopUp("addGridColumnPopUp", false);
    });
  };

  _toggleLoader = flag => {
    this.setState({ showLoader: flag });
  };

  _onFilterChange = event => {
    gridApi.api.setQuickFilter(event.target.value);
    this.setState({ filteredText: event.target.value });
  };

  _onInit = res => {
    this.props
      .getInitData(this.props.pricelistId, res)
      .then(() => {
        this._toggleLoader(false);
      })
      .catch(() => this.props.history.push("/pricebooks"));
  };

  _togglePBActive = () => {
    const priceBook = {
      ...this.props.selectedPricelist,
      active: !this.props.selectedPricelist.active,
    };
    const toasterMsg = priceBook.active
      ? "Pricebook activated successfully"
      : "Pricebook deactivated successfully";
    this.props
      .updatePricebookInfo(priceBook)
      .then(() => {
        Toastr.showToastr({
          type: "success",
          message: toasterMsg,
          timeout: 2000,
        });
        this._togglePopUp("togglePBActiveStatusPopup", false);
      })
      .catch(err => {
        Toastr.showToastr({
          type: "failure",
          message: handleApiErrMsg(err),
          timeout: 3000,
        });
        this._togglePopUp("togglePBActiveStatusPopup", false);
      });
  };

  render() {
    return (
      <div>
        <Conditional if={this.state.showLoader}>
          <Loader label={LOADING_MSG.PRICEBOOK} />
        </Conditional>
        <Conditional if={!this.state.showLoader}>
          <div className="pricebookgrid-topbar">
            <div className="pricebookgrid-topbar-info">
              <Link
                className="pricebookgrid-topbar-priceinfo"
                role="button"
                tabIndex="0"
                to="/pricebooks">
                <span className="pricelist-back">
                  <FontAwesomeIcon icon={["far", "angle-left"]} />
                </span>
              </Link>
              <div className="pricebookgrid-info">
                <span className="pricebook-ic-file">
                  <FontAwesomeIcon icon={["fad", "book-spells"]} />
                </span>
                <div className="quotedetails-title">
                  <span className="pricebookdetails-title">
                    {this.props.selectedPricelist
                      ? this.props.selectedPricelist.name
                      : ""}
                  </span>
                  <span className="quotedetails-info-wrapper">
                    <span className="quotedetails-info-currency">
                      {this.props.selectedPricelist
                        ? this.props.selectedPricelist.currency
                        : ""}
                    </span>
                    <span className="circle-dot" />
                    <span className="quotedetails-info-details">
                      {this.props.selectedPricelist
                        ? this.props.selectedPricelist.desc
                        : ""}
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div className="pricebook-meta">
              {this.props.selectedPricelist &&
                checkUserPermission(
                  PERMISSIONS.PRICEBOOKS.CREATE_PRICEBOOKS,
                ) && (
                  <Fragment>
                    <div className="pricebook-meta-content">
                      <span className="pb-toggle-span">
                        Price Book{" "}
                        {this.props.selectedPricelist.active
                          ? "Active"
                          : "Inactive"}
                      </span>
                      <Input
                        checked={this.props.selectedPricelist.active}
                        isSwitch
                        type="checkbox"
                        onChange={() =>
                          this._togglePopUp("togglePBActiveStatusPopup", true)
                        }
                        value=""
                        data-test="pricebookgrid-checkbox-input"
                      />
                    </div>
                  </Fragment>
                )}
            </div>
          </div>
        </Conditional>
        <Conditional
          if={this.props.columnDefs.length > 0 && !this.state.showLoader}>
          <Fragment>
            <PricelistBar
              togglePopUp={this._togglePopUp}
              onFilterChange={this._onFilterChange}
              filterTxt={this.state.filteredText}
            />
            <div className="pricebookgrid-wrapper">
              <div className="ag-theme-balham pricebookgrid-grid">
                <AgGridWrapper
                  // Grid Data
                  columnData={this.props.columnDefs}
                  rowData={this.props.rowData}
                  // Grid Callbacks
                  onCellValueChanged={this._onCellValueChanged}
                  onDragStopped={this._saveGridState}
                  onGridReady={this._onGridReady}
                  onSortChanged={this._saveGridState}
                  // Grid Functions
                  animateRows
                  deltaRowDataMode
                  frameworkComponents={this.state.frameworkComponents}
                  getContextMenuItems={this._getContextMenuItems}
                  getRowNodeId={data => data.index}
                  rowHeight={34}
                  suppressPropertyNamesCheck
                />
              </div>
            </div>
            <div className="pricebookgrid-footer">
              <div className="pricebookgrid-btns">
                <div className="pricebookgrid-valuewrapper">
                  <div className="pricebookgrid-row-count">
                    {this.props.rowData.length} items
                  </div>
                </div>
              </div>
            </div>
          </Fragment>
        </Conditional>
        <Modal
          open={this.state.showPricebookWizard}
          classNames={{ modal: "pricing-methods-modal" }}
          onClose={() => this._togglePopUp("showPricebookWizard", false)}
          closeOnOverlayClick={false}
          center>
          <PricebookWizard
            colData={this.props.columnDefs}
            currencySymbol={
              CURRENCY_SYMBOL[this.props.selectedPricelist.currency]
            }
            data={PricebookGrid.rowData}
            togglePopUp={this._togglePopUp}
            pricebookName={
              this.props.selectedPricelist
                ? this.props.selectedPricelist.name
                : "selected"
            }
            pricelistId={this.props.pricelistId}
          />
        </Modal>
        <Modal
          open={this.state.addGridColumnPopUp}
          onClose={() => this._togglePopUp("addGridColumnPopUp", false)}
          closeOnOverlayClick={false}
          center>
          <AddGridColumn addColumn={this._addColumn} />
        </Modal>
        <Modal
          open={this.state.togglePBActiveStatusPopup}
          onClose={() => this._togglePopUp("togglePBActiveStatusPopup", false)}
          closeOnOverlayClick={false}
          center>
          <TogglePBStatusPopup
            togglePopUp={this._togglePopUp}
            togglePBActive={this._togglePBActive}
            selectedPricelist={this.props.selectedPricelist}
          />
        </Modal>
        <Modal
          open={this.state.manageColumnPopUp}
          onClose={() => this._togglePopUp("manageColumnPopUp", false)}
          closeOnOverlayClick={false}
          center>
          <AgGridVisibilityCtrl
            page={GRID_PAGE_TYPE.PRICELIST}
            title="Manage columns visibility"
            togglePopUp={() => this._togglePopUp("manageColumnPopUp", false)}
          />
        </Modal>
      </div>
    );
  }
}
PricebookGrid.defaultProps = {};

PricebookGrid.propTypes = {
  // Props
  columnDefs: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  rowData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  pricelistId: PropTypes.string.isRequired,

  // Actions
  addColumn: PropTypes.func.isRequired,
  getInitData: PropTypes.func.isRequired,
  updatePricebookData: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  const { columnDefs, rowData } = state.PricebookStore;
  console.debug(state.PricebookStore);
  return {
    columnDefs,
    rowData,
  };
};

const mapDispatchToProps = {
  addColumn,
  getInitData,
  nukeGridData,
  updateFormRowData,
  updatePricebookData,
  updatePricebookInfo,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(PricebookGrid));



// WEBPACK FOOTER //
// ./src/components/Pricebook/PricebookGrid/PricebookGrid.js